import { ArrowRight } from "lucide-react";
import { useSEO } from "../lib/seo";
import { LIVING_CATEGORIES } from "../data/content";

export default function IntelligentLivingPage({ onBook }) {
  useSEO({
    title: "Intelligent Living — A home that responds",
    description:
      "Comfort, Security, Safety, Entertainment, Access — five quiet pillars of intelligent living, designed by GenieX for India's most discerning homes.",
    path: "/intelligent-living",
    keywords: "intelligent living, smart home India, home automation philosophy, GenieX",
  });

  return (
    <main data-testid="intelligent-living-page" className="bg-[var(--gx-bg)] text-white">
      <section className="relative pt-32 lg:pt-40 pb-16 lg:pb-20 grain">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(201,169,97,0.12),transparent_60%)]" />
        <div className="relative max-w-[1400px] mx-auto px-5 lg:px-10">
          <p className="eyebrow mb-4">A Philosophy</p>
          <h1 className="h1-display max-w-[18ch]">
            Intelligent Living<br />
            <span className="text-gold">is quiet.</span>
          </h1>
          <p className="lead mt-6 max-w-[56ch]">
            We do not believe a home should announce its intelligence. A home should simply
            understand — and respond — quietly, gracefully, before you ask.
          </p>
        </div>
      </section>

      <section className="border-t border-line">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16 lg:py-24 grid md:grid-cols-2 gap-6 lg:gap-8">
          {LIVING_CATEGORIES.map((c) => (
            <div
              key={c.key}
              data-testid={`living-${c.key}`}
              className="border border-line rounded-3xl p-8 bg-[var(--gx-surface)] hover:border-gold/40 transition-colors"
            >
              <p className="eyebrow text-gold">{c.sub}</p>
              <h2 className="font-display text-3xl mt-3">{c.title}.</h2>
              <p className="text-dim text-[14px] leading-relaxed mt-5">{c.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="border-t border-line bg-[var(--gx-black)]">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16 lg:py-24 text-center">
          <h2 className="h2-display max-w-[22ch] mx-auto">Begin your intelligent living journey.</h2>
          <button onClick={onBook} className="btn-gold mt-9 mx-auto">
            Book a Consultation <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </section>
    </main>
  );
}
